module.exports = __webpack_public_path__ + "fonts/NanumGothic.77c9de73.ttf";